import { Grid, Tooltip } from "@mui/material";
import { DatePicker } from "antd";
import { useTheme } from "../../style/theme";
import { useEffect } from "react"; // Import useEffect

const { RangePicker } = DatePicker;

const RangeDatePicker = ({ handleDateChange }) => {
  const { mode } = useTheme(); 

  useEffect(() => {
    const styleId = "range-picker-placeholder-styles";
    if (document.getElementById(styleId)) return;

    const style = document.createElement("style");
    style.id = styleId;
    style.textContent = `
      .range-picker-light .ant-picker-input input::placeholder,
      .range-picker-dark .ant-picker-input input::placeholder {
        // opacity: 1 !important;
      }
      .range-picker-light .ant-picker-input input::placeholder {
        color: #666666 !important;
      }
      .range-picker-dark .ant-picker-input input::placeholder {
        color: #666666 !important;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.getElementById(styleId)?.remove();
    };
  }, []);

  return (
    <Tooltip
      title="Get the Templates between start & end date"
      arrow
      placement="top"
    >
      <Grid item xs={12} md={3} >
        <RangePicker
          className={`range-picker-${mode}`} // Add dynamic class
          style={{
            padding: "7px 6px",
            backgroundColor: mode === "light" ? "#fff" : "#141414",
            color: mode === "light" ? "#666666" : "white",
            border:
              mode === "light" ? "1px solid #c4c4c4" : "1px solid #4a4a4a",
            width: "242px",

          }}
          onChange={handleDateChange}
        />
      </Grid>
    </Tooltip>
  );
};

export default RangeDatePicker;